import lottie from "lottie-web";
// import barba from "@barba/core";
import barbaCss from "@barba/css";

// tell Barba to use the css plugin
// barba.use(barbaCss);

function GetCookie(name) {
  var arg = name + "=";
  var alen = arg.length;
  var clen = document.cookie.length;
  var i = 0;
  while (i < clen) {
    var j = i + alen;
    if (document.cookie.substring(i, j) == arg) return "here";
    i = document.cookie.indexOf(" ", i) + 1;
    if (i == 0) break;
  }
  return null;
}

function isFirstVisit() {
  var visit = GetCookie("FirstTimeVisitCookie");
  if (visit == null) {
    var expire = new Date();
    expire = new Date(expire.getTime() + 7776000000);
    document.cookie =
      "FirstTimeVisitCookie=here; expires=" + expire + ";path=/";
    return true;
  } else {
    addHideClass();
    return false;
  }
}

isFirstVisit() ? playWelcomeAnimation() : removeWelcomeAnimationBackground();

// barba.init({
//   debug: false,
//   timeout: 5000,
//   prevent: ({ el }) => el.classList && el.classList.contains("prevent"), //used for creation page and loading of acf form assets
//   transitions: [
//     {
//       once(data) {
//         if (isFirstVisit()) {
//           playWelcomeAnimation();
//         }
//       },
//       // name: "fade",
//       leave() {
//         if (isFirstVisit()) {
//           removeWelcomeAnimationBackground();
//         }
//       },
//       enter(data) {
//         if (isFirstVisit()) {
//           addWelcomeAnimationBackground();
//         }
//       },
//       beforeEnter(data) {
//         const myContainer = data.next.container;

//         if (isFirstVisit()) {
//           addHideClass();
//         }

//         if (myContainer) {
//           const myScripts = document.querySelectorAll("script");

//           myScripts.forEach((nextScript) => {
//             const src = nextScript.src;

//             if (
//               document.head.querySelector('script[src="' + src + '"]') ==
//               undefined
//             ) {
//               //Have to create a new script element in order for the browser to execute the code
//               const newScript = document.createElement("script");
//               newScript.src = src;
//               newScript.async = true;
//               document.head.append(newScript);

//               nextScript.remove(); // Cleaning up the script in the container;
//             }
//           });
//         }
//       },
//     },
//   ],
// });

// lottie
function playWelcomeAnimation() {
  const loadingAnimationLogo = document.querySelector(
    ".page-load-animation-element"
  );
  const containerLoadAnimation = document.querySelector(
    ".container-page-load-animation"
  );
  const logoAnimation = lottie.loadAnimation({
    container: loadingAnimationLogo,
    renderer: "svg",
    loop: false,
    path: "/wp-content/themes/archireve_2022_theme/assets/images/intro-animation.json",
    autoplay: true,
    progressiveLoad: true,
  });

  logoAnimation.addEventListener("complete", (e) => {
    console.log("loading ?");
    containerLoadAnimation.classList.add("hide");
  });

  logoAnimation.play();
}

function removeWelcomeAnimationBackground() {
  const containerLoadAnimation = document.querySelector(
    ".container-page-load-animation"
  );

  if (containerLoadAnimation) {
    containerLoadAnimation.classList.add("hide");
  }
}

function addWelcomeAnimationBackground() {
  const containerLoadAnimation = document.querySelector(
    ".container-page-load-animation"
  );

  if (containerLoadAnimation) {
    containerLoadAnimation.classList.remove("hide");
  }
}

function addHideClass() {
  const containerLoadAnimation = document.querySelector(
    ".container-page-load-animation"
  );
  containerLoadAnimation && containerLoadAnimation.classList.add("hide");
}
